import { render, staticRenderFns } from "./SecondTarBarItem.vue?vue&type=template&id=17e09de2&scoped=true&"
import script from "./SecondTarBarItem.vue?vue&type=script&lang=js&"
export * from "./SecondTarBarItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondTarBarItem.vue?vue&type=style&index=0&id=17e09de2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e09de2",
  null
  
)

export default component.exports